module.exports = __webpack_public_path__ + "static/media/13.Wrong answer.771a6bfa.mp3";